import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { CuentaBancariaService } from "src/app/services/cuenta-bancaria.service";
import { ModalConfirmComponent } from "src/app/shared/components/modal-confirm/modal-confirm.component";
import { saldo_documento } from "src/app/shared/object/saldo_documento.model";
import { RutService } from "src/app/shared/services/rut.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { ValidadoresService } from "src/app/shared/validadores/validadores";
import { TipoMensaje } from "src/Wheel.Styles.HighVolume/Mensaje";
import { BancoService } from '../../../services/banco.service';
import { ProveedorService } from '../../../services/proveedor.service';
import { DatesService } from '../../../shared/services/dates.service';
import { CcProveedorPagosCabeceraComponent } from "./cc-proveedor-pagos-cabecera/cc-proveedor-pagos-cabecera/cc-proveedor-pagos-cabecera.component";
import { CcProveedorPagosListasComponent } from "./cc-proveedor-pagos-listas/cc-proveedor-pagos-listas/cc-proveedor-pagos-listas.component";

@Component({
  selector: "app-cc-proveedor-pagos",
  templateUrl: "./cc-proveedor-pagos.component.html",
  styleUrls: ["./cc-proveedor-pagos.component.scss"],
  providers: [SecurityService, ValidadoresService]
})
export class CcProveedorPagosComponent implements OnInit {
  rutEmpresa: number;
  sucursalEmpresa:number;
  listaProveedores:any;
  listaDeuda: any;
  listaTotales= {
    total_abono:0,
    total_deuda:0,
    total_monto:0,
    total_pago:0
  };
  listaTotalesCanje = {
    total_abono:0,
    total_deuda:0,
    total_monto:0,
    total_pago:0
  }
  listaFormaPago:any;
  listaCanje:any;
  listaBancos:any;
  optionsDatosBancos: Array<any> = [];

  listaBancosEmpresa:Array<any> = [];
  optionsDatosBancosEmpresa: Array<any> = [];

  listaDatosCuenta:any;
  optionsDatosCuenta:Array<any> = [];

  listaDatosCuentaTrans:any;
  optionsDatosCuentaTrans: Array<any> = [];


  public conformePago:boolean=false;

  public frmCheque: FormGroup;
  public submittedCheque:boolean=false;
  public frmTransferencia: FormGroup;
  public submittedTransferencia:boolean=false;

  public frmEfectivo: FormGroup;
  public submittedEfectivo:boolean=false;

  public frmDeposito: FormGroup;
  public submittedDeposito:boolean=false;


  public rutProveedorSel;
  public nombreProveedorSel;
  public rutUsuario;

  public paginaActual = 1;

  @ViewChild(CcProveedorPagosCabeceraComponent, { static: true }) cabeceraComponent: CcProveedorPagosCabeceraComponent;
  @ViewChild(CcProveedorPagosListasComponent, {static:true}) listaComponent: CcProveedorPagosListasComponent;
  @ViewChild('confirmarPagoModal', { static: true }) modalConfirm: ModalConfirmComponent
  @ViewChild('limpiarModal', { static: true }) limpiarModal: ModalConfirmComponent
  checkAll: boolean = false;
  countSelect: number = 0;
  totalFormaPago:number=0;
  DifAPagar: number = 0; //DIFERENCIAL A PAGAR
  MontoPagar:  string = ''; //MONTO PAGO
  SaldoPago: number = 0; // DIFERENCIAL - MONTO

  constructor(
    private proveedorDeudaService: ProveedorService,
    private toastService: ToastService,
    public rutService: RutService,
    private bancoService: BancoService,
    private cuentaBancaria: CuentaBancariaService,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    public router: Router,
    private datesService: DatesService,
  ) {}

  get habilitarPago() {
    return this.conformePago && this.SaldoPago <= 0;
  }

  optionsBancos: Array<any> = [];

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.createFormFPCheque();
    this.createFormFPDeposito();
    this.createFormFPEfectivo();
    this.createFormFPTrans();
    this.loadBancosEmpresa();
    this.loadBancos();
    this.formChangesSubscriptions();
  }



  iniciaConforme(totalPago){
    this.conformePago=true;
    this.DifAPagar = totalPago;
    this.SaldoPago = this.DifAPagar;
    this.MontoPagar = this.DifAPagar.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  formChangesSubscriptions() {
    this.frmCheque.get('banco').valueChanges.subscribe(data => {
      this.frmCheque.get('nroCuenta').setValue('');
      if (this.frmCheque.controls["banco"].value == "" ||
        this.frmCheque.controls["banco"].value == undefined ||
        this.frmCheque.controls["banco"].value == null) {
      } else {
        this.cambiaBanco(this.frmCheque.controls["banco"].value);
      }
    });


    // this.frmDeposito.get('bancoDeposito').valueChanges.subscribe(data => {
    //   this.frmDeposito.get('nroCuentaDeposito').setValue('');
    //   if (this.frmDeposito.controls["bancoDeposito"].value == "" ||
    //     this.frmDeposito.controls["bancoDeposito"].value == undefined ||
    //     this.frmDeposito.controls["bancoDeposito"].value == null) {
    //   } else {
    //     this.cambiaBancoTrans(this.frmDeposito.controls["bancoDeposito"].value);
    //   }
    // });
  }

  loadBancosEmpresa(){
    this.bancoService.obtenerBancoEmpresas(this.rutEmpresa, true, ({mensajes, respuesta})=>{
    const { registros } = respuesta;
    this.optionsDatosBancosEmpresa = [];
    this.listaBancosEmpresa = [];
    if (registros.length<0){
      this.toastService.warning("No se encontraron bancos");
    }
    let sel: any;
    registros.forEach((element) => {
      sel = { value: element.codigo, label: element.nombre };
      this.listaBancosEmpresa.push(sel);
      this.optionsDatosBancosEmpresa.push(sel);
    });
    if(this.optionsDatosBancosEmpresa.length == 1){
      this.frmCheque.get('banco').setValue(this.optionsDatosBancosEmpresa[0].value);
    }
    //console.log(this.optionsDatosBancosEmpresa);

    });
  }




  loadBancos(){
    this.bancoService.obtenerSegunFiltro("", true, ({mensajes, respuesta})=>{
    const { registros } = respuesta;
    this.optionsDatosBancos = [];
    this.listaBancos = [];
    if (registros.length<0){
      this.toastService.warning("No se encontraron bancos");
    }
    let sel: any;
    registros.forEach((element) => {
      sel = { value: element.codigo, label: element.nombre };
      this.listaBancos.push(sel);
      this.optionsDatosBancos.push(sel);
    });

    });
  }



  createFormFPCheque(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.frmCheque = new FormGroup({
      nroDocumento: new FormControl('', [Validators.required]),
      montoEfectivo: new FormControl(0, [Validators.required, Validators.min(1)]),
      fechaDesde: new FormControl(currentDate, [Validators.required]),
      banco: new FormControl('', [Validators.required]),
      nroCuenta:  new FormControl('', [Validators.required])
    });
  }
  createFormFPTrans(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

   this.frmTransferencia = new FormGroup({
    // nroDocumento: new FormControl(0, [Validators.required, Validators.min(1)]),
    montoEfectivo : new FormControl(0, [Validators.required, Validators.min(1)]),
     banco: new FormControl('', [Validators.required]),
     nroCuenta: new FormControl('', [Validators.required]),
     fechaDesde: new FormControl(currentDate,[Validators.required]),
   });
  }

  createFormFPEfectivo(){
    this.frmEfectivo = new FormGroup({
      montoEfectivo: new FormControl(0, [Validators.required, Validators.min(1)]),
    });
  }

  createFormFPDeposito(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.frmDeposito = new FormGroup({
      nroDeposito: new FormControl('', [Validators.required]),
      montoEfectivo: new FormControl(0, [Validators.required, Validators.min(1)]),
      fechaDesde: new FormControl(currentDate, [Validators.required]),
      bancoDeposito: new FormControl('', [Validators.required]),
      nroCuentaDeposito: new FormControl('', [Validators.required]),

    });
  }

  checkAllChange({ checked }) {
    this.listaFormaPago.forEach(detalle => { detalle.seleccionado = checked })
    //SELECCIONAR TODO
    this.checkAll = checked

    //ELEMENTOS SELECCIONADOS
    this.countSelect = this.listaFormaPago.filter(x => x.seleccionado === true).length;
  }




  iniciaProcesoPago(rutSel){
    this.rutProveedorSel= rutSel;
    this.listaComponent.loadPagosProveedor(this.rutProveedorSel);
    this.listaComponent.habilitaConforme=true;
    this.cabeceraComponent.deshabilita();
  }

loadPagosProveedor(){
  this.proveedorDeudaService.getObtenerDeudaProveedor(this.rutEmpresa, this.sucursalEmpresa, this.rutProveedorSel, this.paginaActual, ({ mensajes, respuesta }) => {
    const { registros } = respuesta;
    if (registros.count<0){
      this.toastService.warning("No se encontraron registros");
    }
    this.listaDeuda = registros;
    this.loadPagosProveedorTotales();
    this.loadDocumentosCanjeProveedor();
  });
}

eliminaPago(){

  var atleastOneSelected = this.listaFormaPago.filter(checkbox => checkbox.seleccionado === true);


    if (atleastOneSelected.length === 0) {
      this.countSelect = 0;
      this.toastService.error('No existen registros para eliminar')
      return
    }

    var UnSelectData = this.listaFormaPago.filter(checkbox => checkbox.seleccionado === false);
    this.listaFormaPago = UnSelectData;

    if (this.checkAll === true) {
      this.countSelect = 0;
    }



    this.checkAll = false;

    this.sumaFormaPago();

}

sumaFormaPago(){
  let valorinicial=0;

  const val = this.listaFormaPago.reduce((valoranterior, data)=> valoranterior + data.monto, valorinicial)

  this.totalFormaPago= val;


  this.SaldoPago = this.DifAPagar - this.totalFormaPago;
  this.MontoPagar = this.SaldoPago > 0 ? this.SaldoPago.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : '0';
}

private _updateValueAndValidity(frm:FormGroup) {

  for (let controlName in frm.controls) {
      let con = frm.get(controlName);
      con.updateValueAndValidity();

  }
}

agregaPagoCheque(){
  const TIPO_PAGO = 1;
  const TIPO_CUENTA_BANCARIA =0;
  this.submittedCheque=true;
  if (!this.frmCheque.valid){
   return

  }
  else{
    if ((this.listaFormaPago===undefined) || (this.listaFormaPago ===null)){
      this.listaFormaPago=[];
    }
    this.listaFormaPago.forEach(element => {
      delete element['__typename'];
      delete element['seleccionado'];
    });

    delete this.listaFormaPago['__typename'];
    console.log('MONTO ABONO', this.frmCheque.get('montoEfectivo').value);
    console.log('TOTAL ABONO', this.listaTotales.total_abono);
    console.log('LISTA FORMA DE PAGO', this.listaFormaPago);
    this.proveedorDeudaService.getAddFormaPago(
      this.rutEmpresa, this.sucursalEmpresa, TIPO_PAGO,
      TIPO_CUENTA_BANCARIA, this.frmCheque.get('banco').value,
      this.frmCheque.get('nroCuenta').value,
      this.frmCheque.get('montoEfectivo').value,
      this.frmCheque.get('nroDocumento').value,
      this.listaTotales.total_abono,
      this.frmCheque.get('fechaDesde').value,
      this.listaFormaPago,
      this.listaCanje,
      ({mensajes, respuesta})=>{
        this.submittedCheque=false;
        if (mensajes.length > 0 && mensajes.some(m => m.tipo === TipoMensaje.ERROR)){
          this.toastService.error(mensajes[0].texto, 'Error al procesar pago');
          return;
        }
        // console.log(respuesta);
        this.listaFormaPago = respuesta.forma_pago;
        this.listaFormaPago.forEach(element => {
          element["seleccionado"]=false;
        });
        this.totalFormaPago = respuesta.total_forma_pago;
        this.limpiarForm();

        this.SaldoPago = this.DifAPagar - this.totalFormaPago;
        this.MontoPagar = this.SaldoPago.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    );
  }
}

agregaPagoTrf(){
  const TIPO_PAGO = 2;
  const TIPO_CUENTA_BANCARIA =1;

  this.submittedTransferencia=true;

  if (!this.frmTransferencia.valid)
  return

  if (this.frmTransferencia.valid){
    if ((this.listaFormaPago===undefined) || (this.listaFormaPago ===null)){
      this.listaFormaPago=[];
    }
    this.listaFormaPago.forEach(element => {
      delete element['__typename'];
      delete element['seleccionado'];
    });
    delete this.listaFormaPago['__typename'];
    this.proveedorDeudaService.getAddFormaPago(
      this.rutEmpresa, this.sucursalEmpresa, TIPO_PAGO,
      TIPO_CUENTA_BANCARIA, this.frmTransferencia.get('banco').value,
      this.frmTransferencia.get('nroCuenta').value,
      this.frmTransferencia.get('montoEfectivo').value,
      0,
      this.listaTotales.total_abono,
      this.frmTransferencia.get('fechaDesde').value,
      this.listaFormaPago,
      this.listaCanje,
      ({mensajes, respuesta})=>{
        this.submittedTransferencia=false;
        if (mensajes.length > 0 && mensajes.some(m => m.tipo === TipoMensaje.ERROR)){
          this.toastService.error(mensajes[0].texto, 'Error al procesar pago');
          return;
        }
        // console.log(respuesta);
        this.listaFormaPago = respuesta.forma_pago;
        this.listaFormaPago.forEach(element => {
          element["seleccionado"]=false;
        });
        this.totalFormaPago = respuesta.total_forma_pago;
        this.limpiarForm();

        this.SaldoPago = this.DifAPagar - this.totalFormaPago;
        this.MontoPagar = this.SaldoPago.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    );
  }
}

agregaPagoDeposito(){
  const TIPO_PAGO = 4;
  const TIPO_CUENTA_BANCARIA =1;
  this.submittedDeposito=true;

  if (!this.frmDeposito.valid)
  return

  if ((this.listaFormaPago===undefined) || (this.listaFormaPago ===null)){
    this.listaFormaPago=[];
  }
  this.listaFormaPago.forEach(element => {
    delete element['__typename'];
    delete element['seleccionado'];
  });
  delete this.listaFormaPago['__typename'];
  this.proveedorDeudaService.getAddFormaPago(
    this.rutEmpresa, this.sucursalEmpresa, TIPO_PAGO,
    TIPO_CUENTA_BANCARIA, this.frmDeposito.get('bancoDeposito').value,
    (String)(this.frmDeposito.get('nroCuentaDeposito').value),
    this.frmDeposito.get('montoEfectivo').value,
    this.frmDeposito.get('nroDeposito').value,
    this.listaTotales.total_abono,
    this.frmDeposito.get('fechaDesde').value,
    this.listaFormaPago,
    this.listaCanje,
    ({mensajes, respuesta})=>{
      this.submittedDeposito =false;
      if (mensajes.length > 0 && mensajes.some(m => m.tipo === TipoMensaje.ERROR)){
        this.toastService.error(mensajes[0].texto, 'Error al procesar pago');
        return;
      }
      // console.log(respuesta);
      this.listaFormaPago = respuesta.forma_pago;
      this.listaFormaPago.forEach(element => {
        element["seleccionado"]=false;
      });
      this.totalFormaPago = respuesta.total_forma_pago;
      this.limpiarForm();

      this.SaldoPago = this.DifAPagar - this.totalFormaPago;
      this.MontoPagar = this.SaldoPago.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  );
}

agregaPagoEfectivo(){
  const TIPO_PAGO = 3;
  const TIPO_CUENTA_BANCARIA =0;
  this.submittedEfectivo=true;
  console.log(this.frmEfectivo.valid);
  if (this.frmEfectivo.valid){
    if ((this.listaFormaPago===undefined) || (this.listaFormaPago ===null)){
      this.listaFormaPago=[];
    }
    this.listaFormaPago.forEach(element => {
      delete element['__typename'];
      delete element['seleccionado'];
    });
    delete this.listaFormaPago['__typename'];
    this.proveedorDeudaService.getAddFormaPago(
      this.rutEmpresa, this.sucursalEmpresa, TIPO_PAGO,
      TIPO_CUENTA_BANCARIA, 0,
      '',
      this.frmEfectivo.get('montoEfectivo').value,
      0,
      this.listaTotales.total_abono,
      null,
      this.listaFormaPago,
      this.listaCanje,
      ({mensajes, respuesta})=>{
        this.submittedEfectivo =false;
        if (mensajes.length > 0 && mensajes.some(m => m.tipo === TipoMensaje.ERROR)){
          this.toastService.error(mensajes[0].texto, 'Error al procesar pago');
          return;
        }
        // console.log(respuesta);
        this.listaFormaPago = respuesta.forma_pago;
        this.listaFormaPago.forEach(element => {
          element["seleccionado"]=false;
        });
        this.totalFormaPago = respuesta.total_forma_pago;
        this.limpiarForm();
        
        this.SaldoPago = this.DifAPagar - this.totalFormaPago;
        this.MontoPagar = this.SaldoPago.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    );
  }
}

loadPagosProveedorTotales(){
  this.proveedorDeudaService.getObtenerDeudaProveedorTotales(this.listaDeuda, ({ mensajes, respuesta}) => {
    if ((respuesta === null) || (respuesta==undefined))
    {
      this.toastService.warning("No se encuentran registros");
    }
    else
    {
      this.listaTotales = respuesta;
    }
  } );
}


cambiaBancoTrans(event:any){
  //Al cambiar banco, se debe refrescar el tipo de cuenta
  this.cuentaBancaria.obtenerCuentaEmpresa(this.rutEmpresa, event, true, ({mensajes, respuesta})=>{

    if ((respuesta===null) || (respuesta ===undefined)){
      this.listaDatosCuentaTrans = [];
      this.optionsDatosCuentaTrans = [];
      this.toastService.warning("No se encuentra cuenta bancaria");

    }
    else{
      if (respuesta.registros.length<=0){
        this.listaDatosCuentaTrans = [];
        this.optionsDatosCuentaTrans = [];
        this.toastService.warning("No se encontró la cuenta");
      }
      else{
        let sel: any;
        this.optionsDatosCuentaTrans = [];
        this.listaDatosCuentaTrans = [];
        respuesta.registros.forEach(element => {
          sel = { value: element.banco_codigo, label: element.numero_cuenta };
          this.listaDatosCuentaTrans.push(sel);
          this.optionsDatosCuentaTrans.push(sel);
        });

        if (this.optionsDatosCuentaTrans.length === 1) {
          this.frmTransferencia.get('nroCuenta').setValue(this.optionsDatosCuentaTrans[0].value);
        }
        //console.log(respuesta.registros);
      }

    }
  });
}


cambiaBanco(event:any){
  //Al cambiar banco, se debe refrescar el tipo de cuenta
  this.cuentaBancaria.obtenerCuentaEmpresa(this.rutEmpresa, event, true, ({mensajes, respuesta})=>{
    if ((respuesta===null) || (respuesta ===undefined)){
      this.listaDatosCuenta = [];
      this.optionsDatosCuenta = [];
      this.toastService.warning("No se encuentra cuenta bancaria");

    }
    else{
      if (respuesta.registros.length<=0){
        this.listaDatosCuenta = [];
        this.optionsDatosCuenta = [];
        this.toastService.warning("No se encontró la cuenta");
      }
      else{
        let sel: any;
        this.optionsDatosCuenta = [];
        this.listaDatosCuenta = [];

        respuesta.registros.forEach(element => {
          sel = { value: element.numero_cuenta, label: element.numero_cuenta };
          this.listaDatosCuenta.push(sel);
          this.optionsDatosCuenta.push(sel);
        });

        if(this.optionsDatosCuenta.length == 1){
          this.frmCheque.get('nroCuenta').setValue(this.optionsDatosCuenta[0].value);
        }
        //console.log(respuesta.registros);
      }

    }
  });
}

validateConforme():boolean{
    //Validar si hay alguno seleccionado
    let haySeleccion=false;
    let hayMonto=false;
    this.listaDeuda.forEach(element => {
      if (element.seleccion)
      {
        haySeleccion=true;
        if (element.abono===0){
            hayMonto=false;

        }else{
          hayMonto=true;
        }

      }
    });

    if (!haySeleccion){
      this.toastService.warning('Debe seleccionar algún documento', 'Falta información');
      return false;
    }
    else{
      if (!hayMonto){
        this.toastService.warning('Si selecciona un documento, debe ingresar el monto a pagar');
        return false;
      }

    }

    return true;
}

enviaConforme()
{
  if (!this.validateConforme())
  {
    return;
  }


  this.proveedorDeudaService.setConforme(this.listaDeuda, ({ mensajes, respuesta }) => {

    if (mensajes.length>0){
      mensajes.forEach(element => {
        if (element.tipo==="ERROR"){
          this.toastService.error(element.texto);
        }
        else{
          this.toastService.warning(element.texto);
        }
      });
    }
    else{
      const { saldoDocumento } = respuesta;

      if (saldoDocumento.count<0){
        this.toastService.warning("No se encontraron registros");
      }
      else{
        this.loadPagosProveedorTotales();
        this.bloqueaDoctos();
        this.conformePago=true;
      }
    }



  });
}

showModalConfirm() {
  this.modalConfirm.show(() => { this.enviaGrabar() })
}

enviaGrabar()
{
  this.listaDeuda = this.listaComponent.listaDeuda;
  this.listaCanje = this.listaComponent.listaCanje;

  this.listaDeuda.forEach(element => {
    delete element['__typename'];
  });
  if ((this.listaCanje===undefined) || (this.listaCanje===null)){
    this.listaCanje=[];
  }
  else{
    this.listaCanje.forEach(element => {
      delete element['__typename'];
    });
  }


  this.listaFormaPago.forEach(element => {
    delete element['__typename'];
    delete element['seleccionado'];
  });

  this.listaComponent.sumaConforme()
  this.listaDeuda.forEach(element => {
    element.abono = Number(element.abono.toString().replace(/\./g, ''));
  });

  let enti:any = {
    empresa_rut: this.rutEmpresa,
    sucursal_codigo: this.sucursalEmpresa,
    cliente_proveedor_rut: this.rutService.QuitarDV(this.rutProveedorSel),
    rut_recaudador: this.rutUsuario,
    saldoDocumento:this.listaDeuda,
    canjeDocumento: this.listaCanje,
    forma_pago: this.listaFormaPago,
    monto_coforme: this.listaComponent.totalConforme
  };

  this.proveedorDeudaService.setPago(enti, ({ mensajes, respuesta }) => {

    if (mensajes.length>0){
      mensajes.forEach(element => {
        if (element.tipo==="ERROR"){
          this.toastService.error(element.texto);
        }
        else{
          this.toastService.warning(element.texto);
        }
      });
    }
    else{
      this.toastService.success("Pago realizado");
      this.limpiar();

      // const { saldoDocumento } = respuesta;

      // if (saldoDocumento.count<0){
      //   this.toastService.warning("No se encontraron registros");
      // }
      // else{

      //   // this.loadPagosProveedorTotales();
      //   // this.bloqueaDoctos();
      // }
    }
  });
}

limpiarForm(){
  this.frmCheque.reset();
  this.frmDeposito.reset();
  this.frmEfectivo.reset();
  this.frmTransferencia.reset();

  const { currentDate } = this.datesService.GetStartAndCurrentMonth()

  // CHEQUE
  this.frmCheque.get('banco').setValue(null)
  this.frmCheque.get('nroCuenta').setValue(null)
  this.frmCheque.get('montoEfectivo').setValue(0)
  this.frmCheque.get('nroDocumento').setValue(null)
  this.frmCheque.get('fechaDesde').setValue(currentDate)

  // DEPOSITO
  this.frmDeposito.get('bancoDeposito').setValue(null)
  this.frmDeposito.get('nroCuentaDeposito').setValue(null)
  this.frmDeposito.get('montoEfectivo').setValue(null)
  this.frmDeposito.get('nroDeposito').setValue(0)
  this.frmDeposito.get('fechaDesde').setValue(currentDate)

  // EFECTIVO
  this.frmEfectivo.get('montoEfectivo').setValue(0)

  // TRANSFERENCIA
  this.frmTransferencia.get('banco').setValue(null)
  this.frmTransferencia.get('nroCuenta').setValue(null)
  this.frmTransferencia.get('montoEfectivo').setValue(0)
  this.frmTransferencia.get('fechaDesde').setValue(currentDate)

}

// limpiar(){
//   this.listaCanje=[];
//   this.listaDeuda=[];
//   this.listaFormaPago=[];
//   this.rutProveedorSel="";
//   this.cabeceraComponent.enabled=true;
//   this.listaComponent.enabled=true;
//   this.listaComponent.listaCanje=[];
//   this.listaComponent.listaDeuda=[];
//   this.frmCheque.reset();
//   this.frmDeposito.reset();
//   this.frmEfectivo.reset();
//   this.frmTransferencia.reset();
//   this.cabeceraComponent.nombreProveedorSel="";
//   this.cabeceraComponent.formProveedor.reset();
//   this.cabeceraComponent.formBus.reset();
//   this.listaComponent.listaTotales={
//     total_abono:0,
//     total_monto:0,
//     total_deuda:0,
//     total_pago:0
//   };
//   this.listaComponent.listaTotalesCanje={
//     total_abono:0,
//     total_monto:0,
//     total_deuda:0,
//     total_pago:0
//   };
//   this.totalFormaPago=0;
//   this.habilitaPago=false;
//   this.listaComponent.habilitaConforme=false;
//   this.listaComponent.limpiarFiltro();
// }

validarLimpiar() {
  this.limpiarModal.show(() => {
    this.limpiar();
  })
}
limpiar() {
  this.listaCanje = [];
  this.listaDeuda = [];
  this.listaFormaPago = [];
  this.totalFormaPago = 0;
  this.DifAPagar = 0;
  this.SaldoPago = 0;
  this.MontoPagar = '';
  this.countSelect = 0;
  this.checkAll = false;
  this.conformePago = false;

  this.limpiarForm();

  this.listaComponent.limpiar();
  this.cabeceraComponent.limpiar();
}

bloqueaDoctos(){
  this.cabeceraComponent.deshabilita();
}

loadDocumentosCanjeProveedor(){
  this.proveedorDeudaService.getObtenerDocumentosCanjeProveedor(this.rutProveedorSel, this.sucursalEmpresa, this.rutEmpresa, 1, -1, ({mensajes, respuesta}) => {
    if ((respuesta === null) || (respuesta === undefined)){
      if (mensajes.length>0){
        this.toastService.info(mensajes[0].texto);
      }
      this.listaCanje= [saldo_documento];
    }
    else{
      if (mensajes.length>0){
        this.toastService.info(mensajes[0].texto);
      }
      else
      {
        this.listaCanje = respuesta.registros;
      }
      this.listaComponent.loadPagosProveedorTotalesCanje();
    }

  });
}


}
